import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const TaskBulkMemberCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedTaskCount = 0, taskBulkMemberOptions = [] } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Assign member to ${selectedTaskCount} ${pluralize("task", selectedTaskCount)}`}
            options={taskBulkMemberOptions}
        />
    );
};
